import { createContext, useContext, type MouseEvent } from 'react';
import type { TaskAttachment } from '@shared/types/tasks';

/** Opens a task file in the task's viewer (TaskAttachmentViewerProvider). */
export const OpenAttachmentContext = createContext<((attachmentId: string) => void) | null>(null);

/**
 * Props for a link to a task file: a click opens it in the viewer, while Ctrl/⌘-click, middle-click
 * and "Open link in new tab" still open the file itself. Outside a viewer it's a plain new-tab link.
 */
export function useAttachmentLink(a: TaskAttachment) {
  const open = useContext(OpenAttachmentContext);
  return {
    href: a.url,
    target: '_blank',
    rel: 'noreferrer',
    onClick: open
      ? (e: MouseEvent) => {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          open(a.id);
        }
      : undefined,
  };
}
